export const LEGAL_CONFIG = {
  serviceName: "BadmintonArbiter",
  serviceDomains: ["badmintonarbiter.com", "badmintonarbiter.pl"],
  // Osoba fizyczna, nie przedsiębiorca — stąd brak NIP/REGON. Adres jest wymagany
  // przez art. 5 ust. 2 ustawy o świadczeniu usług drogą elektroniczną.
  administratorName: "Wojciech Reza",
  administratorAddress: "ul. Kazimierza Wielkiego 5/1, 44-100 Gliwice",
  contactEmail: "wojciechreza@gmail.com",
  hostingProvider: "OVH (OVH Sp. z o.o. / OVH SAS) — serwery w Unii Europejskiej",
  lastUpdated: "14 sierpnia 2026",
} as const;

export const PUBLIC_RESULT_SOURCES = [
  { name: "bo5.pl / CitySports", url: "https://bo5.pl" },
  { name: "hastalavista.pl (liga deblowa i open)", url: "https://hastalavista.pl" },
  { name: "deblowaliga.pl (liga Bieruń)", url: "https://deblowaliga.pl" },
  { name: "tournament.tools", url: "https://tournament.tools" },
  { name: "pzbad.tournamentsoftware.com", url: "https://pzbad.tournamentsoftware.com" },
] as const;
